export const detailedViewDescription = ['To view this chart as a summary,', 'switch to Quick View.'];
export const activeDescription = ['Hover over any bar to view question details, or switch to Detailed View.'];
